import React from 'react'
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { Box } from '@mui/system';
import IImage from './IImage';

interface Props {
    images: IImage[];
    setGridMode: () => void;
    setCurrentImage: () => void;
    screenWidth: number;
};

const PortfolioModalImageGrid: React.FunctionComponent<Props> = ({ images, setGridMode, setCurrentImage, screenWidth }) => {

    const { apiUrl } = window.appConfig;

    const gridImageClick = (index: number) => {
        setCurrentImage(index)
        setGridMode(false)
    }

    return (
        <Box sx={{ width: '100%', height: '100%', p: '5px' }}>
            {screenWidth < 1200 ?
                <ImageList variant="masonry" gap={5}
                    sx={{
                        mb: 0,
                        columnCount: {
                            xs: '1 !important',
                            sm: '2 !important',
                            md: '3 !important'
                        },
                    }}>
                    {images.map((image: any, index: number) => (
                        <ImageListItem
                            key={index}
                            onClick={() => gridImageClick(index)}
                            sx={{
                                '&:hover': {
                                    md: {
                                        cursor: 'pointer',
                                        filter: 'brightness(0.8) grayscale(1)'
                                    }
                                }
                            }}
                        >
                            <img
                                src={`${apiUrl}/file/${image.reference}`}
                                loading="lazy"
                                aria-label='grid-image'
                            />
                        </ImageListItem>
                    ))}
                </ImageList>

                : <ImageList variant='standard' cols={3} sx={{ mb: 0 }}>
                    {images.map((image: any, index: number) => (
                        <ImageListItem
                            key={index}
                            onClick={() => gridImageClick(index)}
                            sx={{
                                '&:hover': {
                                    md: {
                                        cursor: 'pointer',
                                        filter: 'brightness(0.8) grayscale(1)'
                                    }
                                }
                            }}
                        >
                            <img
                                style={{ aspectRatio: '1' }}
                                src={`${apiUrl}/file/${image.reference}`}
                                loading="lazy"
                                aria-label='grid-image'
                            />
                        </ImageListItem>
                    ))}
                </ImageList>

            }

        </Box>
    )
}

export default PortfolioModalImageGrid